import router from "@/router";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;

export default class CommonApi {

    // получение токена если уже авторизован
    protected _getConfig(): AxiosRequestConfig {
        let token;
        // если в локалсторадже есть токен, то берем его
        const cacheState = localStorage.getItem('piniaState');
        if (cacheState !== null) {
            token = JSON.parse(cacheState).auth.token;
        } return {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    }

    protected _errorHandler = (err: AxiosError) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
            Notify.create({ message: "Произошла ошибка авторизации. Пожалуйста, зарегистрируйтесь заново, если это не произошло автоматически", color: "negative", position: "bottom" });
            axios.get(`${'/api/admin/SaveError/'}${err.message}`).then((res) => {return Promise.resolve(res.data)});
            router.push({ name: "login" });
        } else {
            const errMessArr = err.response?.request.responseText.match(/[а-яА-ЯёЁ]+/g);

            axios.get(`${'/api/admin/SaveError/'}${err.message}`).then((res) => {return Promise.resolve(res.data)});

            if (errMessArr && errMessArr.length > 0) {
                Notify.create({ message: "Произошла ошибка: " + errMessArr.join(" "), color: "negative", position: "bottom", icon: "error" })
            } else {
                Notify.create({ message: "Произошла ошибка", color: "negative", position: "bottom", icon: "error" })
            }
        }
    }

    public getWithToken(url: string): Promise<any> {
        return axios.get(url, this._getConfig()).then((res) => {
            return Promise.resolve(res.data);
        }).catch((err: AxiosError) => {
            this._errorHandler(err);
            return Promise.reject(err);
        });
    }

    public postWithToken(url: string, data: any, message: string): Promise<any> {
        return axios.post(url, data, this._getConfig()).then((res) => {
            Notify.create({ message: message, color: "info", position: "bottom", icon: "done" });
            return Promise.resolve(res.data);
        }).catch((err: AxiosError) => {
            this._errorHandler(err);
        });
    }

    public putWithToken(url: string, data: any, message: string): Promise<any> {
        return axios.put(url, data, this._getConfig()).then((res) => {
            Notify.create({ message: message, color: "info", position: "bottom", icon: "done" });
            return Promise.resolve(res.data);
        }).catch((err: AxiosError) => {
            this._errorHandler(err);
        });
    }

    public getWithBlob(url: string): Promise<any> {
        let token = "";
        const cacheState = localStorage.getItem('piniaState');
        if (cacheState !== null) {
            token = JSON.parse(cacheState).auth.token;
        }

        return axios.get(url, {
            responseType: "blob", headers: {
                Authorization: "Bearer " + token
            }
        }).then((res) => {
            return Promise.resolve(res.data);
        }).catch((err: AxiosError) => {
            this._errorHandler(err);
        });
    }

    protected rolesUrl = `/api/admin/CheckGroups/`;

    public checkRoles(): Promise<any> {
        return this.getWithToken(this.rolesUrl);
    }

    // protected tokenUrl: string;

    // constructor() {
    //     this.tokenUrl = "/api/settings/token/";
    // }
}